import { TMasterSkillTest } from "@/api/entities/master-skill-test.entity";
import { setHiddenSkillTestApi } from "@/api/services/global/master";
import { Modal } from "@/components/elements/Modal";
import { API_SUCCESS_MESSAGE } from "@/constants/common";
import { QUERY_KEYS } from "@/constants/queryKeys";
import { showError } from "@/utils/error";
import { toNumber } from "@/utils/number";
import { toast } from "@/utils/toast";
import { Typography } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import { Dispatch, FC, SetStateAction } from "react";

type THiddenSkillTestModalProps = {
  hiddenSkillTest?: TMasterSkillTest;
  setHiddenSkillTest: Dispatch<SetStateAction<TMasterSkillTest | undefined>>;
};

export const HiddenSkillTestModal: FC<THiddenSkillTestModalProps> = ({ hiddenSkillTest, setHiddenSkillTest }) => {
  const queryClient = useQueryClient();

  const handleSubmit = async () => {
    if (!hiddenSkillTest) return;
    try {
      await setHiddenSkillTestApi(toNumber(hiddenSkillTest.id), { isHidden: !hiddenSkillTest.isHidden });
      toast.success(API_SUCCESS_MESSAGE);
      setHiddenSkillTest(undefined);
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.GLOBAL.MASTER_SKILL_TEST] });
    } catch (error) {
      showError(error);
    }
  };

  return (
    <Modal
      title={hiddenSkillTest?.isHidden ? "有効化の確認" : "無効化の確認"}
      isOpen={!!hiddenSkillTest}
      onClose={() => setHiddenSkillTest(undefined)}
      enableCloseIcon={false}
      labelClose="キャンセル"
      labelOk="保存"
      onOk={() => handleSubmit()}
    >
      <Typography variant="body14" component="p" sx={{ paddingY: 2 }}>
        {hiddenSkillTest?.isHidden ? "この行が有効化されますが、よろしいですか。" : "この行が無効化されますが、よろしいですか。"}
      </Typography>
    </Modal>
  );
};
